export class START {
    Type: string = "START";
    SerialNumber: string;
    StartDate: Date;
    EndDate: Date;
    Duration: number;
}